const STRINGS = {
  monthAriaLabel: "Month",
  yearAriaLabel: "Year"
};
export default STRINGS;